import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface EquipamentoKpiItem {
  icon: string;
  iconClass: string;
  value: string | number;
  label: string;
  valueClass?: string;
  wide?: boolean;
}

@Component({
  selector: 'app-equipamento-kpi-grid',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './equipamento-kpi-grid.component.html',
  styleUrl: './equipamento-kpi-grid.component.scss'
})
export class EquipamentoKpiGridComponent {
  @Input() items: EquipamentoKpiItem[] = [];
  @Input() columns = 4;

  @HostBinding('style.--kpi-cols') get kpiCols(): number { return this.columns; }
}
